<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_PERSON_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.person;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(person) {
      console.log("person",person);
      var filtered_person = this.deepFilterEntryWithAllowedFieldsForMutation(person, person.validations)
      console.log("fil person",filtered_person);
      // console.log("PERSON", person, person.validations, this.deepFilterEntryWithAllowedFieldsForMutation(person, person.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_PERSON_MUTATION,
          variables: {
            input: filtered_person
          }
        })
        .then(response => {
          var errors = response.data.updatePerson.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry)
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_PERSON_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      person(id: $id) {
        id
        code
        kind
        leadingCompanyId
        sellerId
        regionId
        labelId
        birthDate
        cpf
        cnpj
        tablePriceId
        isCollaborator
        isCustomer
        isSupplier
        isCarrier
        isEmployee
        isDriver
        observation
        rg
        role
        hourlyPrice
        contractType {
          id
          name
        }
        contractTypeId
        name
        tradingName
        email
        phone
        cellPhone
        isFinalConsumer
        recipientStateInscription
        addressesAttributes {
          id
          cityId
          city {
            id
            name
            state {
              id
            }
          }
          postalCode
          street
          neighborhood
          number
          complement
          validations
          canBeDeleted
          undeletabilityReasons
        }
          customerCulturesAttributes {
            id
            harvestId
            harvest{
              id
              name
            }
            cultureId
            culture{
              id
              name
            }
            plantedUnitId
            plantedUnit{
              id
              name
            }
            plantedArea
            globalUnitId
            globalUnit{
              id
              name
            }
            globalArea
            irrigatedUnitId
            irrigatedUnit{
              id
              name
            }
            irrigatedArea
            producedUnitId
            producedUnit{
              id
              name
            }
            produced
            isRented
            technicalLevel
            rentedQuantity
            validations
          }
        routes{
          id
          name
        }
        routeIdsAttribute
        patrimoniesAttributes {
          brand {
            brandType
            id
            name
          }
          loadCapacity
          tare
          wheeledType
          bodyType
          rntc
          brandId
          chassi
          description
          id
          model
          patrimonyCategory {
            id
            name
          }
          patrimonyCategoryId
          plate
          plateState {
            id
            name
            shortName
          }
          plateStateId
          year
          canBeDeleted
          undeletabilityReasons
        }
        taxPayersAttributes {
          id
          stateInscription
          canBeDeleted
          undeletabilityReasons
        }
        salePackagingsAttributes{
          id
          packagingId
          packaging{
            id
            name
          }
          itemId
          item{
            id
            name
          }
        }
        recipientStateInscriptionIndicatorId
        recipientStateInscription
        taxRegimeId
        taxReceiptEmail
        validations
      }
      allTablePrices{
        id 
        name
      }
      allClients{
        id
        name
      }
      allMyCustomers{
        id
        name
      }
      allMyEmployees{
        id
        name
      }
      allRegions{
        id
        description
      }
      allPeopleLabels {
        id
        description
        colorHexaCode
        labelType
      }
    }
    globalContext {
      allPersonKinds {
        value
        text
      }
      allRecipientStateInscriptionIndicators {
        id
        code
        description
      }
      allTaxRegimes {
        id
        code
        description
      }
      allContractTypes {
        id
        name
      }
    }
  }
`;

const UPDATE_PERSON_MUTATION = gql `
  mutation($input: PersonUpdateInputObject!) {
    updatePerson(input: $input) {
      person {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

<!-- mutation {
  updatePerson(
    id: 10,
    input: {
      kind: 1,
    cnpj: "00000000000000",
      isCollaborator: false,
      isCustomer: false,
      isSupplier: true,
      isCarrier: true,
      name: "philips programmator2",
      tradingName: "Pessoa2",
      taxReceiptEmail: "philips_programmator@agrosim.com.br",
      addressesAttributes: [
        {
          postalCode: "93900000",
          cityId: 1100015,
          street: "Logradouro",
          neighborhood: "Bairro",
          number: "Nº",
          complement: "Complemento",
        }
      ]
  }) {
    person {
      id
    }
    errors
  }
} -->
